import { Link } from 'react-router-dom';
import { useAppSelector } from '../../hooks/redux';
import { AppFooter } from './AppFooter';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { isAuthenticated, user } = useAppSelector(state => state.auth);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <header className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="h-16 flex items-center justify-between">
            <Link to="/" className="text-xl font-semibold text-gray-900">
              Glassshop
            </Link>
            <nav className="flex items-center space-x-6">
              <Link to="/" className="nav-link">
                Home
              </Link>

              {isAuthenticated ? (
                <>
                  <Link to="/dashboard" className="nav-link">
                    Dashboard
                  </Link>
                  <span className="text-sm text-gray-600">
                    Welcome, {user?.username}
                  </span>
                </>
              ) : (
                <Link
                  to="/login"
                  className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors"
                >
                  Log in
                </Link>
              )}
            </nav>
          </div>
        </div>
      </header>
      <main className="flex-1 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 w-full">
        {children}
      </main>
      <AppFooter />
    </div>
  );
};
